import { render, staticRenderFns } from "./AppBar.vue?vue&type=template&id=3aa36b3c&scoped=true"
import script from "./AppBar.vue?vue&type=script&lang=js"
export * from "./AppBar.vue?vue&type=script&lang=js"
import style0 from "./AppBar.vue?vue&type=style&index=0&id=3aa36b3c&lang=scss"
import style1 from "./AppBar.vue?vue&type=style&index=1&id=3aa36b3c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa36b3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aa36b3c')) {
      api.createRecord('3aa36b3c', component.options)
    } else {
      api.reload('3aa36b3c', component.options)
    }
    module.hot.accept("./AppBar.vue?vue&type=template&id=3aa36b3c&scoped=true", function () {
      api.rerender('3aa36b3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/vertical/AppBar.vue"
export default component.exports